// components
import {
  initHeader
} from "./components/header";
import {
  initFooter
} from "./components/footer";
import {
  newsletterSection
} from "./components/newsletter";
import {
  mapSection
} from "./components/map";
import {
  showroomSection
} from "./components/showroom";
import {
  benefitsSection
} from "./components/benefits";
import {
  benefitsHpSection
} from "./components/benefits-hp";
import {
  initProductBox
} from "./components/product-box";
import {
  cta
} from "./components/cta";
import {
  partnersSection
} from "./components/partners";
import {
  categoriesSection
} from "./components/categories";
import {
  founderSection
} from "./components/founder";
import {
  cardsSection
} from "./components/cards";

// pages
import initProductDetail from "./pages/product-detail";
import initProductList from "./pages/product-list";
import initKolaNaZakazkuPage from './pages/kola-na-zakazku'

console.log("Custom JS loaded");

const retinaImages = () => {
  const productsDataSrcImages = [...document.querySelectorAll(".products img[data-src]")];

  const replaceAttributeValue = (img, attributeName) => {
    const attributeValue = img.getAttribute(attributeName);
    img.setAttribute(attributeName, attributeValue.replace("/detail/", "/big/"));
  };

  productsDataSrcImages.forEach((img) => {
    replaceAttributeValue(img, "src");
    replaceAttributeValue(img, "data-src");
  });
};

const debugImages = () => {
  const shopImages = document.querySelectorAll("img");
  if (shopImages) {
    shopImages.forEach((image) => {
      const imageSrc = image.getAttribute("src");

      if (imageSrc && !imageSrc.includes('data:')) {
        let srcParametersChar = "?";
        if (imageSrc.includes("?")) {
          srcParametersChar = "&";
        }
        image.setAttribute(
          "src",
          `${imageSrc}${srcParametersChar}v=${Date.now()}`
        );
      }
    });
  }
};

// custom blocks
const initBlocks = () => {
  const indexPage = $(".type-index");
  const categoryPage = $(".type-category");
  const productPage = $(".type-product");
  const articlePage = $(".type-page");
  const contactPage = $(".in-kontakt");
  const customBuildPage = $(".in-kola-na-zakazku");

  // homepage
  if (indexPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
    $(showroomSection).insertBefore("#footer");
    $(
      cta(
        "cta__container--right cta--seo",
        "seo-1.jpg",
        "",
        "Showroom jízdních kol v Praze",
        "Showroom Future Cycling je kamenná prodejna silničních a horských kol v Praze na Kavčích horách, kde samotný výběr silničního, horského nebo dětského kola je zážitkem. Specializujeme se na stavby kol na zakázku, precizní a profesionální servis, provozujeme také testovací centrum jízdních kol a zapletených karbonových setů kol.      "
      )
    ).insertBefore("#footer");
    $(
      cta(
        "cta__container--left cta--seo",
        "seo-2.jpg",
        "",
        "Future Cycling e-shop",
        "FC e-shop Vám nabízí jedny z nejzajímavějších cyklistických produktů na českém trhu. Máme silné zázemí v našem profesionálním MTB Teamu Canyon Northwave a našich osobních závodních zkušenostech. Díky tomu můžeme porovnat, posoudit a doporučit ta nejlepší horská a jízdní kola, cyklistické oblečení, komponenty a doplňky na kola, které na trhu jsou. Cyklistika je naší vášní, životním stylem a prací. Vášní, kterou s Vámi budeme rádi sdílet."
      )
    ).insertBefore("#footer");

    $(benefitsHpSection).insertBefore(".showroom");
    $(partnersSection).insertBefore(".benefits");
    $(categoriesSection).insertBefore(".partners");
    $(founderSection).insertBefore(".custom-categories");
    $(cardsSection).insertBefore(".cta--founder");
    $(
      cta(
        "cta__container--right",
        "cta-test-centrum.jpg",
        "Test centrum",
        "Vyjímečné produkty ENVE, Argon18, 3T, TIME a OPEN",
        "",
        "/test-centrum",
        "Více o testování"
      )
    ).insertBefore(".showroom");
    $(
      cta(
        "cta__container--left",
        "cta-mtb-team.jpg",
        "MTB Team",
        "Profesionální MTB Team Canyon Northwave",
        "",
        "https://team.futurecycling.cz/",
        "Více o MTB Teamu"
      )
    ).insertBefore(".showroom");
  }

  // product list
  if (categoryPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
    $(showroomSection).insertBefore("#footer");
    $(benefitsSection).insertBefore(".showroom");
    $(
      cta(
        "cta__container--right",
        "cta-test-centrum.jpg",
        "Test centrum",
        "Vyjímečné produkty ENVE, Argon18, 3T, TIME a OPEN",
        "",
        "/test-centrum",
        "Více o testování"
      )
    ).insertBefore(".showroom");
    $(
      cta(
        "cta__container--left",
        "cta-mtb-team.jpg",
        "MTB Team",
        "Profesionální MTB team Canyon Northwave",
        "",
        "https://team.futurecycling.cz/",
        "Více o MTB Teamu"
      )
    ).insertBefore(".showroom");
  }

  // detail product
  if (productPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
    $(showroomSection).insertBefore("#footer");
    $(benefitsSection).insertBefore(".showroom");
  }

  // user page
  if (articlePage.length > 0 && !contactPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
    $(showroomSection).insertBefore("#footer");
    $(benefitsHpSection).insertBefore(".showroom");
  }

  // contact page
  if (contactPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
  }

  // custom build bikes
  if (customBuildPage.length > 0) {
    // $(newsletterSection).insertBefore("#footer");
    // $(mapSection).insertBefore(".newsletter");
    $(showroomSection).insertBefore("#footer");
    $(benefitsHpSection).insertBefore(".showroom");
  }
};

// Init app
window.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initFooter();
  initBlocks();
  initProductDetail();
  initProductList();
  initProductBox();
  initKolaNaZakazkuPage()
  retinaImages();
  debugImages();
});